import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/lightbulb': {
    width: 352,
    height: 512,
    paths: [
      {
        d: 'M176 80c8.8 0 16 7.2 16 16s-7.2 16-16 16c-35.3 0-64 28.7-64 64 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-52.9 43.1-96 96-96zM96.1 459.2l0-43.2h160l-0.1 43.2c0 3.1-0.9 6.2-2.7 8.8l-24.5 36.8c-3 4.5-8 7.1-13.3 7.1h-78.8c-5.4 0-10.4-2.7-13.3-7.1l-24.5-36.8c-1.8-2.6-2.7-5.7-2.7-8.8zM176 0c97.2 0 176 78.8 176 176 0 44.4-16.5 84.8-43.5 115.8-16.6 19-42.7 58.8-52.4 92.2v0h-48v-0.1c0-4 1-10.4 2.2-14.3 5.7-18 23-64.8 62.1-109.5 20.4-23.3 31.7-53.2 31.7-84.1 0-70.6-57.4-128-128-128-68.3 0-128.2 54.4-128 128 0.1 31 11.1 60.7 31.6 84.1 39.3 44.9 56.6 91.9 62.2 109.7 1.4 4.6 2.1 9.3 2.2 14.1v0.1h-48v-0.1c-9.7-33.4-35.8-73.2-52.4-92.2-27.1-30.9-43.6-71.4-43.6-115.8 0-93 73.7-176 176-176z'
      }
    ]
  }
})
